/* src/app/forms/painel-correios/cep-buscaobjeto/cep-buscaobjeto.component.scss */
.card-model {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.mat-mdc-card-title {
  font-size: 180%;
}
.card-content {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: row;
}
:host {
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
}
.cep-fields-grid {
  display: flex;
  flex-direction: row;
  height: 100%;
  width: 100%;
}
.key-class {
  font-size: 80%;
  font-weight: 500;
}
.value-class {
  font-size: 80%;
}
.message-class {
  display: flex;
  flex-direction: column;
}
.columns-data {
  width: 100%;
  padding: 2px;
}
.columns-data-detail {
  width: 20%;
  padding: 2px;
  font-size: 80%;
}
.vl {
  border-left: 1px solid gray;
  height: 30px;
  margin-left: 4px;
  margin-right: 4px;
}
.message {
  font-size: 80%;
}
.title-card {
  width: 100%;
  justify-content: space-between;
  display: flex;
  flex-direction: row;
}
mat-form-field {
  width: 100%;
}
.resultado {
  display: flex;
  width: 100%;
  overflow: auto;
}
.cep {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}
.cep-content {
  display: flex;
  flex-direction: column;
  height: fit-content;
}
.mat-mdc-card-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
}
.li-data {
  cursor: pointer;
  width: 100%;
}
.overlay-frame {
  width: 250px;
  padding: 5px;
  overflow: auto;
  border-radius: 5px 0 0 5px;
  border-style: solid;
  border-color: #ccc;
  border-width: 1px;
  background-color: white;
}
.overlay-frame .name {
  font-size: 80%;
  font-weight: 500;
}
.overlay-frame .edit {
  font-size: 80%;
  text-overflow: ellipsis;
  display: block;
  white-space: nowrap;
  overflow: hidden;
}
.overlay-frame .line {
  padding-bottom: 10px;
}
.overlay-frame .linepar {
  background-color: whitesmoke;
  padding-left: 10px;
}
.overlay-frame .lineimp {
  padding-left: 10px;
}
/*# sourceMappingURL=cep-buscaobjeto.component.css.map */
